import { createSelector } from 'reselect';

const substate = (state) => state.policies;

export const selectView = () => createSelector(substate, (contextState) => contextState.view);
